import React from 'react';
import {UI} from 'components';
import {first, useNamedSelector} from 'helpers';

export function Chart({id, force}) {
  const { chartPeriod = 7 } = useNamedSelector('goals.options');
  const { progressType } = useNamedSelector('goals.goal', { id });
  const period = useNamedSelector('calendar.lastDays', { length: chartPeriod });
  const { total, value } = useNamedSelector('goals.progressSummary', { id });
  const data = useNamedSelector('goals.progressChart', { id, date: first(period) });

  let color = 'green';
  if (total && value / total < 1/3) {
    color = 'danger';
  } else if (total && value / total < 2/3) {
    color = 'orange';
  }

  return (data.length > 0 || force) && (
    <UI.Chart
      className="spacing"
      color={color}
      data={data}
      period={period}
      total={total}
      type={progressType}
    />
  );
}
